import { ListItem, styled } from "@mui/material";

import { List } from "@/Components/v2/atoms/List";
import { Stack } from "@/Components/v2/atoms/Stack";
import { BoldSpan, Typography } from "@/Components/v2/atoms/Typography";
import { formatPercentage } from "@/pages/scenario-builder/utils";
import { ToolTipLegendCircle } from "@/Utils/ECharts/ToolTipLegendCircle";

interface ToolTipSpendPercentageProps {
  revenue: { seriesName: string; value: string | number; color: string }[];
  spend: { seriesName: string; value: string | number; color: string }[];
  totalRevenue: number;
  totalSpend: number;
  totalAggregateRevenue: number;
  totalAggregateSpend: number;
  revenueLabel: string;
}

const ToolTipSpendPercentage: React.FC<ToolTipSpendPercentageProps> = ({
  revenue,
  spend,
  totalRevenue,
  totalSpend,
  totalAggregateRevenue,
  totalAggregateSpend,
  revenueLabel,
}) => {
  const filteredSpend = spend.filter((item) => item.value !== 0);
  const filteredRevenue = revenue.filter((item) => item.value !== 0);

  return (
    <ToolTipContainer>
      {/* Spend */}
      <Stack paddingTop={1} paddingRight={4} alignItems="flex-start">
        <Typography variant="body1" fontWeight={600}>
          Marketing Spend
        </Typography>
        <List>
          {filteredSpend.map((item, index) => (
            <ListItem key={index}>
              <ToolTipLegendCircle color={item.color} border={item.color} />
              <Typography variant="body2">
                <BoldSpan>{item.seriesName.split(" ")[0]}</BoldSpan>
                <Typography>
                  {totalAggregateSpend !== 0 ? formatPercentage(Number(item.value), true) : "N/A"}
                </Typography>
              </Typography>
            </ListItem>
          ))}
          <ListItem>
            <Typography variant="body2">
              <BoldSpan>Total Spend</BoldSpan>
              <Typography>{formatPercentage(totalSpend, true)}</Typography>
            </Typography>
          </ListItem>
        </List>
      </Stack>

      {/* Revenue */}
      <Stack paddingTop={1} paddingRight={1} alignItems="flex-start">
        <Typography variant="body1" fontWeight={600}>
          Marketing {revenueLabel}
        </Typography>
        <List>
          {filteredRevenue.map((item, index) => (
            <ListItem key={index}>
              <ToolTipLegendCircle color={item.color} border={item.color} />
              <Typography variant="body2">
                <BoldSpan>{item.seriesName.split(" ")[0]}</BoldSpan>
                <Typography>
                  {totalAggregateRevenue !== 0 ? formatPercentage(Number(item.value), true) : "N/A"}
                </Typography>
              </Typography>
            </ListItem>
          ))}
          <ListItem>
            <Typography variant="body2">
              <BoldSpan>Total {revenueLabel} </BoldSpan>
              <Typography>{formatPercentage(totalRevenue, true)}</Typography>
            </Typography>
          </ListItem>
        </List>
      </Stack>
    </ToolTipContainer>
  );
};

export default ToolTipSpendPercentage;

const ToolTipContainer = styled("div")(() => {
  return {
    display: "flex",
  };
});
